import React, { useEffect, useState } from "react";
import { FaUser, FaLock } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ApiHandler } from "../../helper/ApiHandler";
import { setUserToken, setUserData } from '../../redux/slices/userSlice';
import Loading from "../../components/Loading";

const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { userToken } = useSelector((state) => state.user);
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    useEffect(() => {
        // Redirect to admin page if already logged in
        if (userToken) {
            navigate("/");
        }
    }, [userToken, navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();

        if (!username.trim() || !password.trim()) {
            toast.error("Please enter both email and password");
            return;
        }

        try {
            setLoading(true);

            const response = await ApiHandler("/login.php", "POST", {
                username,
                password,
            }, undefined, dispatch, navigate);

            const { token } = response?.data?.data || {};

            if (response?.data && response.data.status === '1') {
                dispatch(setUserToken(token));
                dispatch(setUserData(response.data.data));

                toast.success(response.data.msg || "Login successful");
                navigate('/admin/dashboard');
            } else {
                toast.error(response?.data?.msg || "Invalid username or password");
            }
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.msg || "Invalid username or password");
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <Loading />;
    return (
        <div className="flex items-center justify-center min-h-screen bg-[#f2f2f2] login paddingX">
            <div className="w-full max-w-md bg-[#f2f2f2] shadow-lg rounded-lg px-8 py-10"
                style={{
                    boxShadow: '13px 13px 20px #cbced1, -13px -13px 20px #ffffff',
                    borderRadius: '15px'
                }}>
                <div className="lander-heading text-[2.5em]">
                    Login
                </div>
                <form className="text-[#111111] text-base" onSubmit={handleLogin}>
                    <div className="space-y-3 mb-4">
                        <label htmlFor="userid" className="block text-sm font-semibold mb-2">
                            User ID
                        </label>
                        <div className="relative">
                            <FaUser className="absolute top-1/2 left-4 transform -translate-y-1/2 text-gray-400" />
                            <input
                                type="text"
                                placeholder="Enter your User Id"
                                className="w-full pl-12  focus:outline-none rounded-[25px] bg-transparent shadow-none py-[5px]"
                                style={{
                                    boxShadow: 'inset 8px 8px 8px #cbced1, inset -8px -8px 8px #ffffff'
                                }}
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                            />
                        </div>
                    </div>
                    {/* Password Field */}
                    <div className="space-y-3 mb-4">
                        <label htmlFor="userid" className="block text-sm font-semibold mb-2">
                            Password
                        </label>
                        <div className="relative">
                            <FaLock className="absolute top-1/2 left-4 transform -translate-y-1/2 text-gray-400 cursor-pointer" onClick={() => setShowPassword(!showPassword)} />
                            <input
                                type={showPassword ? "text" : "password"}
                                id="password"
                                placeholder="Enter your password"
                                className="w-full pl-12 focus:outline-none rounded-[25px] bg-transparent py-[5px]"
                                style={{
                                    boxShadow: "inset 8px 8px 8px #cbced1, inset -8px -8px 8px #ffffff",
                                }}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>
                    </div>
                    <button
                        type="submit"
                        className="w-full sidebar-bg-responsive hover:bg-red-300 text-white font-bold py-2 rounded-md"
                    >
                        LOGIN
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;
